//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/NXObject.js";
let d=[[],[[["numFaces","faces"],"GetFaces",{},0,0],[["numFeatureData","featureDataVec"],"GetFeatureDataVector",{},0,0],[["faces","featureDataVec"],"Add",{},2,0],[["featureType","faces","featureDataVec"],"AddNew",{},3,0],[["faces","featureDataVec"],"Set",{},2,0],[["faces","featureDataVec"],"Remove",{},2,0]],[]];
SPLM.MBD.SemanticFeatureData = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.SemanticFeatureData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MBD.SemanticFeatureData.FeatureType = Object.freeze({
    "Individual" : "Individual", "Compound" : "Compound", "Pattern" : "Pattern", "Group" : "Group", "Array" : "Array"});

export default SPLM;